module.exports = __webpack_public_path__ + "static/13-e1c504cb17d5ffbc047ee9143bdde4e7.jpeg";